<template>
  <div id="make-entry" class="bg2">
    <h2 class="shrink text-center logo-small mb-2">
      <span class="primary--text">New Entry</span>
    </h2>
      <v-card class="sticky bg3">
        <v-card-subtitle class="py-0">
          <v-text-field ref='refEntryName' hide-details="auto" dense outlined class="py-2" label="Entry Name" v-model="currentPick.name" placeholder="Entry Name"></v-text-field>
        </v-card-subtitle>
        <v-card-text class="px-4 py-0">
          <v-sheet class="d-flex justify-space-between bg3">
            <span>Select teams below</span>
            <v-btn text small color="green" @click="clearAllTeams">Clear All</v-btn>
          </v-sheet>
          <v-sheet class="mb-1 pa-1 border-grey bg2" min-height="72px" max-width="368px">
            <v-chip label x-small :small="$vuetify.breakpoint.smAndUp" close class="pl-0 mr-1 mb-1" v-for="team in currentTeams" :key="team[1].name" @click:close="pickTeam(team[0])">
              <v-avatar tile class="mr-2 grey">{{team[1].seed}}</v-avatar>{{team[1].name}}
            </v-chip>
          </v-sheet>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between px-6">
          <v-sheet class="mr-5 subtitle accent--text bg3" :class="{'headline': $vuetify.breakpoint.smAndUp}">
            Teams: {{currentPick.teams.length}}
          </v-sheet>
          <v-sheet class="mr-5 subtitle accent--text bg3" :class="{'headline': $vuetify.breakpoint.smAndUp}">
            Left: ${{moneyLeft}}
          </v-sheet>
          <v-btn :small="$vuetify.breakpoint.xsOnly" color="success" @click="submitCurrentPick">
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card scrollable>
        <v-tabs v-model="currentRegion">
          <v-tab v-for="region in regions" :key="region">
            {{region}}
          </v-tab>
        </v-tabs>
          <v-tabs-items v-model="currentRegion">
            <v-tab-item v-for="region in regions" :key="region">
              <v-list dense style="max-height: 300px" class="overflow-y-auto">
                  <v-list-item v-for="team in sortedTeams[currentRegion]" :key="team[0]" @click="pickTeam(team[0])">
                    <v-list-item-avatar>{{team[1].seed}}</v-list-item-avatar>
                    <v-list-item-title>{{team[1].name}}</v-list-item-title>
                    <v-icon v-if="currentPick.teams.indexOf(team[0])>-1">mdi-check</v-icon>
                  </v-list-item>
              </v-list>
            </v-tab-item>  
          </v-tabs-items>
      </v-card>
  </div>
</template>

<script>
import { fa } from '../db'
import { mxPicks } from '../mixins/mxPicks'

export default {
  name: 'Home',
  mixins: [mxPicks],
  data() {
    return {
      currentPick: { 
        name: null, 
        teams: [], 
        uid: (fa.currentUser) ? fa.currentUser.uid : 'testuser',
      },
      regions: ["West", "East", "South", "Midwest"],
      currentRegion: null
    }
  },
  computed: {
    teams() {
      return this.$store.getters.teams
    },
    picks() {
      return this.$store.getters.picks
    },
    status() {
      return this.$store.getters.status
    },
    sortedTeams() {
      let t = [[],[],[],[]]
      this.teams.forEach((r, i) => {
        for (let team in r) {
          t[i][r[team].seed -1] = [team, r[team]]
        }
      })
      return t
    },
    userPicksNum () {
      let n = 0
      this.picks.forEach(p => {
        if (p.uid == fa.currentUser.uid) n++
      })
      return n
    },
    currentTeams() {
      return this.currentPick.teams.map(t => {
        let r = Number(t.substring(1,2)) - 1
        return [t,this.teams[r][t]]
      })
    },
    moneyLeft() {
      let ml = 90
      this.currentPick.teams.forEach(t => {
        let r = Number(t.substring(1,2)) - 1
        ml = ml - (17 - this.teams[r][t].seed)
      })
      return ml
    }
  },
  methods: {
    submitCurrentPick() {
      if (!this.currentPick.name) {
        this.$store.dispatch('setSnack', 'Entry Name cannot be blank')
      } else if (this.currentPick.teams.length < 1) {
        this.$store.dispatch('setSnack', 'At least one team must be slected')
      } else if (this.userPicksNum >= 3) {
        this.$store.dispatch('setSnack', 'Max number of entries reached')
      } else if (this.status > 0) {
        this.$store.dispatch('setSnack', 'Games have started, picks no longer allowed')
      } else {
        this.currentPick.total = this.moneyLeft
        this.currentPick.left = this.moneyLeft
        this.currentPick.timestamp = Date.now()
        this.$store.dispatch('pushPick', this.currentPick)
      }
    },
    pickTeam(key) {
      if (this.currentPick.teams.indexOf(key) > -1) {
        this.currentPick.teams.splice(this.currentPick.teams.indexOf(key),1);
      } else {
        if (this.moneyLeft - (17 - this.teams[this.currentRegion][key].seed) < 0) {
          this.$store.dispatch('setSnack', 'Not enough salary remaining')
        } else if (this.currentPick.teams.length > 13) {
          this.$store.dispatch('setSnack', 'Max number of teams reached')
        } else {
          this.currentPick.teams.push(key);
        }
      }  
    },
    isPicked() {
      return true
    },
    clearAllTeams() {
      this.currentPick.teams = []
    }
  },
  mounted() {
    this.$refs.refEntryName.isFocused = true
  }
}
</script>

<style>
  .border-grey { border: 1px solid grey}
  .sticky { position: sticky; z-index: 10; top: 0}
</style>